import styled, { css } from "styled-components";

export const StyledContainer = styled.div<{
  $horizontalAlignment: string;
  $shape: string;
  $length: number;
}>`
  justify-content: ${({ $horizontalAlignment }) =>
    $horizontalAlignment || "inherit"};
  .wrapper {
    width: var(--entity-size);
    /* Mobile: min(user resize, shape-based cap when capped [circle/square 40%, other 60%], original). When --combo-mobile-fill-cell (array 3+ per line), use 100% so media is not resized. Floored by --entity-mobile-min-width so stacked caps never shrink media to nothing. */
    @media screen and (max-width: 768px) {
      width: max(
        var(--entity-mobile-min-width, 40%),
        calc(
          min(
              var(--entity-mobile-width-override, 100%),
              calc(
                100% * (1 - var(--combo-mobile-media-capped, 0)) +
                  var(--entity-mobile-cap-by-shape, 40%) *
                  var(--combo-mobile-media-capped, 0)
              ),
              100%
            ) *
            (1 - var(--combo-mobile-fill-cell, 0)) + 100% *
            var(--combo-mobile-fill-cell, 0)
        )
      );
    }
  }

  .image-wrapper {
    ${({ $shape }) =>
      $shape === "free"
        ? css`
            position: static;
            grid-area: stack;
            display: flex;
            align-items: center;
          `
        : css`
            position: absolute;
          `}
  }
`;

export const ImagesContainerStyled = styled.div<{
  $shape: string;
  $shadow: boolean;
  $round: string;
}>`
  ${({ $shape, $shadow, $round }) => css`
    position: relative;
    ${$shape !== "free" &&
    css`
      box-shadow: ${$shadow ? "rgba(0, 0, 0, 0.15) 0px 4px 8px" : "none"};
      border-radius: ${$round ? $round : "0"};
      overflow: hidden;

      img {
        object-fit: cover;
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
      }
    `}
    ${$shape === "free" &&
    css`
      display: grid;
      grid-template-areas: "stack";
      img {
        box-shadow: ${$shadow ? "rgba(0, 0, 0, 0.15) 0px 4px 8px" : "none"};
        border-radius: ${$round ? $round : "0"};
      }
    `}
    ${$shape === "16-9" &&
    css`
      padding-top: 56.25%;
    `}
    ${$shape === "axis-resize" &&
    css`
      height: var(--entity-height);
    `}
    ${$shape === "square" &&
    css`
      padding-top: 100%;
    `}
    ${$shape === "circle" &&
    css`
      padding-top: 100%;
      border-radius: 50%;
    `}
  `}
`;
